import { render } from "./addDevice.vue?vue&type=template&id=23c1c012&scoped=true"
import script from "./addDevice.vue?vue&type=script&lang=js"
export * from "./addDevice.vue?vue&type=script&lang=js"

import "./addDevice.vue?vue&type=style&index=0&id=23c1c012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c1c012"]])

export default __exports__